import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAttachFile = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.4576 9.38091L7.9253 14.9122C7.28377 15.5541 7.28377 16.5944 7.9253 17.2362V17.2362C8.56714 17.8777 9.60744 17.8777 10.2493 17.2362L18.8789 8.60659C19.4953 7.99027 19.8416 7.1543 19.8416 6.28262C19.8416 5.41095 19.4953 4.57498 18.8789 3.95866V3.95866C18.2627 3.34231 17.4269 2.99603 16.5554 2.99603C15.6839 2.99603 14.8481 3.34231 14.2319 3.95866L5.60234 12.5893C4.67766 13.5135 4.15815 14.7673 4.15815 16.0747C4.15815 17.3821 4.67766 18.6359 5.60234 19.5602V19.5602C6.52672 20.4846 7.78048 21.0039 9.08779 21.0039C10.3951 21.0039 11.6489 20.4846 12.5732 19.5602L18.8759 13.2575",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgAttachFile);
export default ForwardRef;
